import { useState } from "react";
import AppPageHeader from "../../components/Headers/AppPageHeader";
import { Button, Container } from "reactstrap";
import BasicTableView from "../supportal/CloudListView/BasicTableView";
import IconButton from "../../elements/IconButton";
import EmailBuilderDrawer from "../../components/Drawers/EmailBuilderDrawer/EmailBuilderDrawer";
import useBulkEmails from "../../api/api-hooks/bulkEmail/useBulkEmails";
import useBulkEmailCRUD from "../../api/api-hooks/bulkEmail/useBulkEmailCRUD";
import { AppConfirm } from "../../utils/PopupUtil";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import { SavedBulkEmailOperations } from "../../components/Drawers/EmailBuilderDrawer/EmailBuilderTypes";

export default function BulkEmailsHome() {
  const [open, setOpen] = useState(false);
  const [editAction, setEditAction] = useState<any>(null);

  const { emailActions, emailActionsLoading } = useBulkEmails();
  const { bulkEmailCRUD, crudLoading } = useBulkEmailCRUD();

  return (
    <>
      <AppHelmet title="Bulk Email Actions - GrowthCloud.com" />
      <Container fluid className="pb-8">
        <AppPageHeader
          title={"Bulk Email Actions"}
          description={`Create and manage the bulk email actions for this cloud`}
          customContent={
            <Button color="primary" onClick={() => setOpen(true)}>
              Add
            </Button>
          }
        />
        <BasicTableView
          loading={emailActionsLoading}
          items={emailActions}
          title={"Actions"}
          getItemTitle={(e) => e?.Name}
          getItemSubtitle={(e) => e?.Description || `${e?.Type} Email Template`}
          emptyMessage="No actions have been added."
          CustomRenderer={(a) => {
            return (
              <div>
                <IconButton
                  icon="content-duplicate"
                  tooltipText="Duplicate Email Action"
                  onClick={() => duplicateEmailAction(a)}
                />
                <IconButton
                  icon="pencil"
                  tooltipText="Edit Email Action"
                  onClick={() => {
                    setOpen(true);
                    setEditAction(a);
                  }}
                />
                <IconButton
                  icon="close"
                  tooltipText="Delete Quick Create"
                  onClick={() => onDeleteAction(a?.id)}
                  color="danger"
                  loading={a?.id === "actionID"}
                />
              </div>
            );
          }}
        />
      </Container>
      <EmailBuilderDrawer
        open={open}
        onClose={() => setOpen(false)}
        onExited={() => setEditAction(null)}
        existing={editAction}
        key={editAction?.id} // Don't remove this!
      />
    </>
  );

  async function onDeleteAction(actionID: string) {
    const res = await AppConfirm({
      title: "Delete Email Action",
      html: "Are you sure you want to delete this email action?<br/>This cannot be undone.",
    });

    if (!res.isConfirmed) return;

    bulkEmailCRUD({ actionID: actionID, action: "Delete" });
  }

  function duplicateEmailAction(a: SavedBulkEmailOperations) {
    const payload: Partial<SavedBulkEmailOperations> = structuredClone(a);

    delete payload.id;
    delete payload._id;
    delete payload.LastUpdated;
    delete payload.LastUpdatedBy;
    delete payload.Created;
    delete payload.CreatedBy;

    payload.Name = `${payload.Name} - Copy`;

    bulkEmailCRUD({
      payload: payload,
      action: "Duplicate",
    });
  }
}
